import { queryFetch } from '../../../core/fetch';
import { newentryActions } from './newentry';

export const types = {
	RESET_LOGIN: 'RESET_LOGIN',
	LOGIN: 'LOGIN',
	CHECK_LOGIN: 'CHECK_LOGIN',
	COOKIE_LOGIN: 'COOKIE_LOGIN',
};

export const loginActions = {
	reset() {
		return (dispatch) => {
			dispatch({
				type: types.RESET_LOGIN,
			});
			deleteCookie('u_cookie_username');
			deleteCookie('u_cookie_fullname');
			dispatch(newentryActions.setShowNewEntry(true));
		};
	},
	checklogin(login) {
		return (dispatch) => {
			dispatch({
				type: types.CHECK_LOGIN,
			});

			dispatch(checkloginfromDB(login));
		};
	},
	setCookieLogin(login) {
		return (dispatch) => {
			dispatch({
				type: types.COOKIE_LOGIN,
				payload: { login },
			});

			dispatch(newentryActions.setShowNewEntry(false));
		};
	},
	login(login, isValid) {
		return (dispatch) => {
			dispatch({
				type: types.LOGIN,
				payload: { login, isValid },
			});
			if (isValid) dispatch(newentryActions.setShowNewEntry(false));
			else dispatch(newentryActions.setShowNewEntry(true));
		};
	},
};

const checkloginfromDB = (login) => {
	const body = JSON.stringify(login);
	return (dispatch) => {
		queryFetch('isLoginValid', '', 'POST', body).then((result) => {
			if (result.isValid) {
				setCookie('u_cookie_username', result.username, 1);
				setCookie('u_cookie_fullname', result.name, 1);
			}
			dispatch(loginActions.login(result, result.isValid));
		});
		// setCookie('u_cookie_username', login.username, 1);
		// setCookie('u_cookie_fullname', login.name, 1);
		// dispatch(loginActions.login(login, login.isValid));
	};
};

const setCookie = (name, value, days) => {
	let expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

const deleteCookie = (name) => {
	document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};
